import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

const RankChangeIndicator = ({ currentRank, previousRank, size = 'default' }) => {
  if (!previousRank || !currentRank) {
    return null;
  }

  const change = previousRank - currentRank; // Positive = rank improved (moved up)
  
  if (change === 0) {
    return (
      <span className={`inline-flex items-center gap-1 text-gray-500 ${size === 'small' ? 'text-xs' : 'text-sm'}`}>
        <Minus className={size === 'small' ? 'h-3 w-3' : 'h-4 w-4'} />
        <span>No change</span>
      </span>
    );
  }

  const isImprovement = change > 0;
  
  return (
    <span 
      className={`inline-flex items-center gap-1 font-semibold ${
        isImprovement ? 'text-green-600' : 'text-red-600'
      } ${size === 'small' ? 'text-xs' : 'text-sm'}`}
    >
      {isImprovement ? (
        <>
          <TrendingUp className={size === 'small' ? 'h-3 w-3' : 'h-4 w-4'} />
          <span>↑ {Math.abs(change)}</span>
        </>
      ) : (
        <>
          <TrendingDown className={size === 'small' ? 'h-3 w-3' : 'h-4 w-4'} />
          <span>↓ {Math.abs(change)}</span>
        </>
      )}
    </span>
  );
};

// Rank Badge with Change Indicator
const RankBadgeWithChange = ({ currentRank, previousRank, showChange = true }) => {
  const getRankBadge = (rank) => {
    if (rank === 1) return '🥇';
    if (rank === 2) return '🥈';
    if (rank === 3) return '🥉';
    return `#${rank}`;
  };

  return (
    <div className="flex items-center gap-2">
      <span className="text-2xl font-bold">
        {getRankBadge(currentRank)}
      </span>
      {showChange && <RankChangeIndicator currentRank={currentRank} previousRank={previousRank} />}
    </div>
  );
};

export { RankChangeIndicator, RankBadgeWithChange };
export default RankChangeIndicator;
